export enum RideStopStatus {
  None = 46,
  EnRoute = 47,
  Arrived = 48, //arrived with no action
  Visited = 49, //arrived with action (pickup or not)
  Skipped = 50,
}

//specify the stop status => order 1
export type RideStopStatusType = 'None' | 'EnRoute' | 'Arrived' | 'Visited' | 'Skipped';

// specify the timing status => order 2
//note these statuses applied on the past (like Arrived, visited, EnRoute) stop not current no upcoming
export type StopArrivalTimeStatus = 'onTime' | 'early' | 'late' | 'alert' | 'none' | 'skipped';

export const StopStatusDescription = (key: number) => {
  switch (key) {
    case RideStopStatus.None:
      return 'None';
    case RideStopStatus.EnRoute:
      return 'En Route';
    case RideStopStatus.Arrived:
      return 'Arrived';
    case RideStopStatus.Visited:
      return 'Visited';
    case RideStopStatus.Skipped:
      return 'Skipped';
    default:
      return 'None';
  }
};
